import queryString from 'query-string';

class UrlParams {
  public static appendUrlParams(params: any, url?: string) {
    if (url) {
      return queryString.stringifyUrl({
        url,
        query: params,
      });
    }
    return queryString.stringify(params);
  }

  public static getUrlParams(url: string, key: string) {
    const { query } = queryString.parseUrl(url);
    return query[key];
  }

  private urlParams: any;
  constructor(url: string) {
    this.urlParams = queryString.parse(url, {
      arrayFormat: 'comma',
    });
  }

  public getCurrentParams(key?: string) {
    return key ? this.urlParams[key] : this.urlParams;
  }
}

export const currentUrlParams = new UrlParams(window.location.search.slice(1));

export default UrlParams;
